<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail input-scan-page" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Attachment Evidence">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
				<app-input-textbox label-cols-lg="12" label="Control Card" id="input-status" size="sm" :model="model.controlCard != null ? model.controlCard.controlCardNumber:'-'" :isEditable="false"/>
					</b-col>
					<b-col cols="12" lg="6"></b-col>
			</b-row>
		</b-card>

		<app-table-input 
			title = "Evidence"
			:bordered="true" :items="evidenceAttachments" 
			:fields="fieldsEvidenceAttachment" 
			:busy="isDataLoading"  small responsive	
      @showPopupAddMethod="addDataEvidenceAttachment()"	
      @deleteButtonMethod="deleteRowDataEvidenceAttachment"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="false"	
			:showDownloadButton="false"	
			:isDownloadBusy="isDownloadEvidenceAttachment"
		>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( evidenceAttachmentPageSize * (currentEvidenceAttachmentPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(evidence)="row">
				<app-input-fileupload :id="'input-evidence-attachment-file-pendukung-' + row.index" label-cols-lg="12" label="File Pendukung" size="sm" :model.sync="filePendukungs[row.item.id]" :currentModel="row.item.evidence" @change="saveInputEvidenceAttachment(row.item)" :isEditable="true"  :nolabel="true" accept="image/*" />
			</template>
		</app-table-input>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<!-- <b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button> -->
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import focusInput from '@/mixins/focusInputMixin';
import PartPurchaseQualityControlDetail from '@/models/PartPurchaseQualityControl/PartPurchaseQualityControlDetail';
import PartPurchaseQualityControlDetailFilter from '@/filters/PartPurchaseQualityControl/PartPurchaseQualityControlDetailFilter';
import toast from '@/mixins/toastMixin';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import PartPurchaseQualityControl from '@/models/PartPurchaseQualityControl/PartPurchaseQualityControl';
import PartPurchaseQualityControlFilter from '@/filters/PartPurchaseQualityControl/PartPurchaseQualityControlFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import ControlCardStatus from '@/models/ControlCardStatus/ControlCardStatus';
import ControlCardStatusFilter from '@/filters/ControlCardStatus/ControlCardStatusFilter';
import AttachmentPartPurchaseQualityControl from '@/models/AttachmentPartPurchaseQualityControl/AttachmentPartPurchaseQualityControl';
import AttachmentPartPurchaseQualityControlFilter from '@/filters/AttachmentPartPurchaseQualityControl/AttachmentPartPurchaseQualityControlFilter';
import PopupRouterView from '@/components/PopupRouterView';
import AppInputScan from '@/components/AppInputScan';
import AppTableInput from '@/components/AppTableInput';
import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model','modelId', 'openPopup','addButtonMethod', 'resetMethod', 'parentLabelInfo', 'parentValueInfo', 'isShowInput'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputTextarea,
		PopupRouterView,
		AppInputScan,
		AppTableInput,
		AppInputFileupload,
	},
	mixins : [validationMixin, toast, focusInput],
	validations: {
		model: {
		controlCardId: {required},
			thickness: {required},
			width: {required},
			length: {required},
		}
	},
	data() {
		return {
			errorMessage : {
				controlCardId: { required : "ControlCard is Required."},
				thickness: { required : "Thickness is Required."},
				width: { required : "Width is Required."},
				length: { required : "Length is Required."},
			},
			fieldsEvidenceAttachment: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"evidence": { "class" : "th-file-pendukung d-stack-none", "label" : "File Pendukung", key: 'evidence', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			controlCards : [],
			controlCardStatuss : [],
			evidenceAttachments : [], 
			sortingByEvidenceAttachment : [],
			isBusy: false,
			currentEvidenceAttachmentPage: 1,
			evidenceAttachmentPageSize: 10,
			filePendukungs: [],
			isDataLoading: false,
			isDownloadEvidenceAttachment: false,
		}
	},
	methods : {
		async deleteRowDataEvidenceAttachment(id,item) {
			await AttachmentPartPurchaseQualityControl.deleteData(this, id).then(result => { this.getEvidenceAttachments(); });
		},
		saveInputEvidenceAttachment(item) {
			this.isDataLoading = true;

			let id = item.id;
			let promises = Array();
			if (this.filePendukungs[id] != null) {
				this.isInputBusy = true;
				let data = new FormData();
				data.append('file', this.filePendukungs[id]);
				let _this = this;
				promises.push(this.$http.post('attachment/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								item.evidenceId = response.data.id;
								item.evidence = response.data;
								_this.filePendukungs[id] = null;
							}
						}

						_this.isInputBusy = false;
						return true;
					})
					.catch(error => {
						this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isInputBusy = false;
						throw error;
					}));
			}


			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					AttachmentPartPurchaseQualityControl.updateData(this, item, item.id);
				}

				this.isDataLoading = false;
			});
			this.isDataLoading = false;
		},
		getEvidenceAttachments : async function(isAddRow) {
			let filter = new AttachmentPartPurchaseQualityControlFilter();
			if (this.model.id == null) return;
			filter.partPurchaseQcDetailId = this.model.id;
			filter.draftMode = '1';
			let currentPage = (this.currentEvidenceAttachmentPage - 1);
			if (isAddRow) {
				let totalData = this.totalEvidenceAttachmentRow + 1;
				let page = Math.ceil(totalData/this.evidenceAttachmentPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.evidenceAttachmentPageSize = 0;
			// disable paging end
			AttachmentPartPurchaseQualityControl.getList(this, filter, null, currentPage , this.evidenceAttachmentPageSize).then(result => {
				this.currentEvidenceAttachmentPage = currentPage + 1;
				this.evidenceAttachments = result.data.sort((a, b) => a.id - b.id);
				this.totalEvidenceAttachmentRow = result.dataCount;
				this.filePendukungs = Array();
				for(var item of result.data) {
					this.filePendukungs[item.id] = null;
				}

			}).catch(error => {});
		},
		async addDataEvidenceAttachment() {
			AttachmentPartPurchaseQualityControl.createData(this, {partPurchaseQcDetailId: this.model.id})
			.then(result => {
				this.getEvidenceAttachments(true);
			})
		},
		getPartPurchaseQualityControlDetail : async function(id) {
			this.isBusy = true;
			PartPurchaseQualityControlDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.id = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data;
					this.model.qty = result.data[0].qtyCase;
				}
			})
			.catch(error => {});
		},
		getControlCardStatuss : async function(input) {
			let filter = new ControlCardStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ControlCardStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCardStatuss = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			let model = this.model;

			if (this.$v.model.$anyError) {
				return;
			} else {
				let promises = Array();
				let _this = this;
					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod"); 
				});

				_this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},
	},	beforeMount() {
		//this.getControlCards();
		//this.getControlCardStatuss();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getPartPurchaseQualityControlDetail(newValue);
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getControlCards(this.model.controlCardId);
				this.getEvidenceAttachments();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getPartPurchaseQualityControlDetail(this.modelId);
				}
			}
		},
		currentEvidenceAttachmentPage: {
			handler: function() {
				this.getEvidenceAttachments();
			}
		},
		evidenceAttachmentPageSize : {
			handler: function() {
				this.getEvidenceAttachments();
			}
		},
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		}
	}
}
</script>
